"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.parameterizationOnDemand", [
    "nucont.shared"
]);
require("./parameterization-on-demand.routes");
